import { z } from 'zod';

/**
 * An id as this system actually mints them: an opaque, non-empty string.
 *
 * The domain schemas used to say `z.string().uuid()`. The phone does generate
 * uuids, so it looked true — but most rows are not born on the phone. The
 * server mints `sess_pier3_q3`, `tpl-bridge-v4-2`, `usr_dev_inspector`; the
 * sync queue mints task ids with `nanoid()`. None of those are uuids, and the
 * pull contract in `./pull` has always typed them as plain strings, so the two
 * halves of the same row disagreed.
 *
 * What that cost: the first pulled session threw inside the hub's list query,
 * which failed the query, which rendered the empty state — so tapping "Sync
 * now" made every session disappear, including local ones that parsed fine.
 *
 * A uuid check on an id is not validation anyway. Ids are compared, not
 * interpreted; the only property worth asserting is that one is present.
 */
export const EntityId = z.string().min(1).max(128);
